export default __webpack_public_path__ + "static/media/task0.a1c08252.png";